const ar_home = {
  // Hero
  "hero.badge": "منصة متقدمة للطب الدقيق والرعاية التخصصية",
  "hero.heading_1": "نفهم قبل",
  "hero.words": "أن نقرر|أن نتدخل|أن نعالج|أن نحكم",
  "hero.desc": "ذا مديكال أفينيو ليست عيادة تقليدية — بل منصة طب دقيق تفكك الحالة وتقرأ ما وراء العرض، وتربط بين الحاضر الصحي والمخاطر المستقبلية.",
  "hero.sub": "جلسات 90–120 دقيقة · تقنيات DNA وتقييم أيضي · Second Opinion دولي · خطط شخصية لا بروتوكولات عامة",
  "hero.btn_book": "احجز جلسة تقييم",
  "hero.btn_services": "استكشف خدماتنا",
  "hero.pillar_1": "عمق سريري",
  "hero.pillar_2": "عمق تقني",
  "hero.pillar_3": "عمق دولي",
  "hero.scroll": "اكتشف المزيد",
  // TrustBar
  "trust.label": "أرقام تعكس تميزنا",
  "trust.tagline": "عيادة متكاملة للطب الدقيق والرعاية التخصصية المتقدمة",

  // FeaturedServices
  "services.badge": "الخدمات",
  "services.heading": "تخصصاتنا وبرامجنا العلاجية",
  "services.desc": "رعاية مخصّصة، تتميّز بعلمها، جاهزة لاستقبالك.",
  "services.view_all": "عرض جميع الخدمات",

  // WhyUs
  "whyus.badge_identity": "هويتنا البصرية",
  "whyus.heading_identity": "أربعة رموز، فلسفة واحدة",
  "whyus.desc_identity": "تجتمع هذه الرموز لتشكّل لغة بصرية للعافية حيث تتعايش العلم، الحيوية، التوازن، والجمال في انسجام تام",
  "whyus.shape_1_label": "الاطباء",
  "whyus.shape_1_sub": "الأطباء · الخبرة الطبية · التقييم المتخصص",
  "whyus.shape_1_desc": "النجمة ترمز إلى الخبرة الطبية والتميز، والتوجيه نحو رعاية موثوقة تبدأ بفهم الحالة قبل اتخاذ القرار.",
  "whyus.shape_2_label": "توازن الرشاقة",
  "whyus.shape_2_sub": "السمنة · الأيض · إدارة الوزن",
  "whyus.shape_2_desc": "البجعة ترمز إلى التوازن والرشاقة، وتعكس نهجًا صحيًا متكاملًا لإدارة الوزن وتحسين الصحة الأيضية",
  "whyus.shape_3_label": "عمق جمالي",
  "whyus.shape_3_sub": "الجمال · النضارة · العناية المتخصصة",
  "whyus.shape_3_desc": "هرة اللوتس ترمز إلى التجدد والجمال المتوازن، حيث تلتقي العناية المتخصصة بالنضارة والثقة بالنفس",
  "whyus.shape_4_label": "عمق الطاقة والحيوية",
  "whyus.shape_4_sub": "العظام · العضلات · النشاط",
  "whyus.shape_4_desc": "الشمس ترمز إلى الحيوية والقوة والنشاط الصحي المستمر، وتعكس أهمية دعم صحة العظام والعضلات للحفاظ على الحركة والقدرة على ممارسة الحياة بنشاط.",
  "whyus.badge": "لماذا ذا مديكال أفينيو؟",
  "whyus.heading": "طب أعمق، أكثر تخصيصًا، ومدعوم بالدقة",
  "whyus.desc_1": "نحن لسنا عيادة أسرع — بل عيادة أعمق. نفكك الحالة ونقرأ ما وراء العرض، ونربط بين الحاضر الصحي والمخاطر المستقبلية.",
  "whyus.desc_2": "كل مريض يملك بيولوجيا ومسارًا صحيًا مختلفًا. لذلك نصمم لكل حالة خطة مبنية على تقييمها الفعلي، لا على بروتوكول عام.",
  "whyus.three_dims": "ثلاثة أبعاد متكاملة",
  "whyus.dim_1": "عمق سريري",
  "whyus.dim_1_sub": "وقت أطول · تقييم غير سريع",
  "whyus.dim_2": "عمق تقني",
  "whyus.dim_2_sub": "DNA · عمر بيولوجي · أيضي",
  "whyus.dim_3": "عمق دولي",
  "whyus.dim_3_sub": "Second Opinion · USA · Korea",
  "whyus.intl": "امتداد دولي",
  "whyus.intl_sub": "USA · Korea · وأكثر",
  "whyus.session": "دقيقة لكل جلسة",
  "whyus.session_sub": "نمنح الحالة الوقت الذي تستحقه",

  // TeamPreview
  "team.badge": "فريقنا الطبي",
  "team.heading": "نخبة من الاستشاريين المتخصصين",
  "team.desc": "كل استشاري في ذا مديكال أفينيو يجمع بين الخبرة السريرية العميقة والتدريب الدولي المتخصص",
  "team.view_all": "عرض جميع الاستشاريين",
  "team.book": "احجز استشارة",

  // FeaturedPackages
  "packages.badge": "مستويات الرعاية",
  "packages.heading": "اختر مستوى التقييم المناسب",
  "packages.desc": "من التقييم العميق الشامل إلى الرعاية الدولية المتكاملة — كل مستوى مصمم لحالة مختلفة",
  "packages.view_all": "عرض جميع الباقات",
  "packages.book": "احجز الآن",

  // Testimonials
  "testimonials.badge": "آراء مرضانا",
  "testimonials.heading": "ماذا يقول من مروا بالتجربة",
  "testimonials.desc": "تجارب حقيقية من مرضى اختاروا الطب الدقيق طريقًا لفهم صحتهم",

  // CTA
  "cta.heading": "جاهز لتقييم صحي حقيقي؟",
  "cta.desc": "ابدأ رحلتك مع ذا مديكال أفينيو — جلسة تقييم عميق تبني صورة واضحة عن مسارك الصحي",
  "cta.btn_book": "احجز جلسة تقييم",
  "cta.btn_contact": "تواصل معنا",

  // DNA Simulator Banner
  "dna_banner.badge": "أداة تفاعلية مجانية",
  "dna_banner.heading": "اكتشف مستوى مخاطرك الصحية",
  "dna_banner.subheading": "DNA Risk Score Simulator",
  "dna_banner.desc": "10 أسئلة تفاعلية تحلل عوامل الخطر الجينية والبيئية لديك — وتوصيك بالباقة الأنسب لمسارك الصحي",
  "dna_banner.btn_start": "ابدأ التقييم — مجاناً",
  "dna_banner.btn_service": "تعرف على الخدمة الحقيقية",
  "dna_banner.free": "مجاني",
  "dna_banner.questions": "10 أسئلة · نتائج فورية",
};

export default ar_home;
